import "@pjs/theming/dist/theme.css";
import { injectCss } from "../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.fbk-notice{--cui-notice-layout-width:auto}.fbk-notice__content{font-weight:var(--font-weight-semi-bold)}`);